import { render, staticRenderFns } from "./OperacionesPage.html?vue&type=template&id=0470aee6&external"
import script from "./OperacionesPage.vue?vue&type=script&lang=ts"
export * from "./OperacionesPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports